module.exports = __webpack_public_path__ + "img/shield-d.bda4298f.png";